import React from 'react'
import Sidenav from './components/Sidenav'
import Completeorders from './components/orders/CompleteOrders'

export default function Completeorder() {
  return (
<div className="flex ">
       <div className="">
       <Sidenav />
       </div>
        <div className="">
            <Completeorders />
        </div>
    </div>  )
}
